import { Service } from "@turizi/shared";

export const HostelTemplate: Partial<Service> = {
    category: 'hostel',

    self_attrs: [
        {
            key: 'stars',
            type: 'text',
            value: null,
            placeholder: '1,2,3,4,5',
            section: 'category_1',
        },
        {
            key: 'regime',
            type: 'text',
            value: null,
            options: ['All Inclusive', 'Media Pension', 'Pension Completa', 'Desayuno', 'Sin Regimen'],
            section: 'category_1',
        },
        {
            key: 'shared_kitchen',
            type: 'boolean',
            value: false,
            section: 'amenities_2',
            sort: 0,
        },
        {
            key: 'swimming_pool',
            type: 'boolean',
            value: false,
            section: 'amenities_2',
            sort: 1,
        },
        {
            key: 'gym',
            type: 'boolean',
            value: false,
            section: 'amenities_2',
            sort: 2,
        },
        {
            key: 'wifi',
            type: 'boolean',
            value: true,
            section: 'amenities_2',
        },
        {
            key: 'parking',
            type: 'boolean',
            value: false,
            section: 'services_3',
        },
        {
            key: 'business_center',
            type: 'boolean',
            value: false,
            section: 'services_3',
        },
        {
            key: 'restaurant',
            type: 'boolean',
            value: false,
            section: 'services_3',
        },
        {
            key: 'check_in',
            type: 'text',
            value: null,
            section: 'policies_4',
        },
        {
            key: 'check_out',
            type: 'text',
            value: null,
            section: 'policies_4',
        },
    ],
    booking_attrs: [
    ]

} as const;

export default HostelTemplate;